import script from "./Pagos.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagos.vue?vue&type=script&setup=true&lang=js"

import "./Pagos.vue?vue&type=style&index=0&id=5341d162&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5341d162"]])

export default __exports__